import { Button, Typography } from 'antd'
import {useCookies} from 'react-cookie';
import { Link} from "react-router-dom";


export const CookieConsentView = () => {
    const [cookies, setCookie] = useCookies(["cookieConsent"]);
    const { Text } = Typography;
    const acceptCookies = ()=> {
        setCookie("cookieConsent", true, {path: "/"});
    }

  return (
    <div
      className={cookies.cookieConsent}
      style={{
        display: "block",
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#f0f2f5",
        color: "#000",
        textAlign: "center",
        paddingBottom: "100px",
        paddingTop: "10px",
        zIndex:"100"
      }}
    >
      <h2>Cookie Notice</h2>
      <Text>
        <p>
          We use cookies and other technologies to improve your browsing
          experience. By continuing to use our website without changing your
          settings, you agree to our use of cookies.
        </p>
      </Text>
      <Text>
        To find out more, see the <Link to="/privacy-statement">Privacy Statement</Link>.{" "} and <Link to="/terms-and-conditions">Terms & Conditions</Link>.{" "} of
        this site.
      </Text>
      <div style={{paddingTop: 10}}>
        <Button size="large" type="primary" about='Click to accept privacy policy and terms & conditions' onClick={acceptCookies}>
          Accept
        </Button>

      </div>
    </div>
  );
}
